import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useMemo, useState } from "react";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useTranslation } from "@i18n";
import RadioCardExpandable from "@/pages/checkout/pre-checkout/RadioCard/RadioCardExpandable";
import FlowButton from "@/pages/sell-my-car/components/FlowButton";
import SAR from "@componentsShared/SAR/SAR";
import UserLocationInspection from "@/pages/sell-my-car/components/UserLocationInspection";
import { If } from "@componentsShared/Conditional/If";
import WorkshopLocations from "@/pages/sell-my-car/components/WorkshopLocations";
import { twMerge } from "tailwind-merge";
import { getAllCities } from "@/pages/price-offer/price-offer-helper";
import ChangeCityModal from "@/pages/sell-my-car/components/ChangeCityModal";
import { submitSellTradeStep } from "@/apis/sell-my-car";
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useNavigate } from "react-router-dom";
import FlowOptionLoading from "@/pages/sell-my-car/components/FlowOptionLoading";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import StepsAndFAQModal from "@/pages/sell-trade-v2/sell-trade/components/StepsAndFAQModal";
import useBoolean from "@hooks/useBoolean";
import { Icon } from "@syarahtech/ui";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import FLowFixedContainer from "@/pages/sell-my-car/components/FLowFixedContainer";
import useMediaQuery from "@hooks/useMediaQuery";
import useIsMobile from "@hooks/useIsMobile";
var CarLocationPickedScreen = function CarLocationPickedScreen() {
  var _state$draftOrder9, _state$draftOrder9$cu, _state$draftOrder20, _dataActions$checkCit, _dataActions$checkCit2, _dataActions$checkCit3, _dataActions$checkCit4, _dataActions$checkCit5, _dataActions$checkCit6;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useScreenNavigation = useScreenNavigation(),
    screenActions = _useScreenNavigation.actions,
    screenState = _useScreenNavigation.state;
  var _useState = useState(null),
    selectedLocation = _useState[0],
    setSelectedLocation = _useState[1];
  var _useSellCarData2 = useSellCarData(),
    dataActions = _useSellCarData2.actions;
  var _useState2 = useState(false),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var navigate = useNavigate();
  var faqModal = useBoolean();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var smallDevice = useMediaQuery("(max-height: 725px)");
  var isMobile = useIsMobile();
  var fees = useMemo(function () {
    var _getAllCities, _city$fees_amount, _city$fees_amount$;
    var city = (_getAllCities = getAllCities()) === null || _getAllCities === void 0 ? void 0 : _getAllCities.find(function (city) {
      var _state$draftOrder, _state$draftOrder$cur, _state$draftOrder$cur2;
      return city.id == (state === null || state === void 0 ? void 0 : (_state$draftOrder = state.draftOrder) === null || _state$draftOrder === void 0 ? void 0 : (_state$draftOrder$cur = _state$draftOrder.currentStep) === null || _state$draftOrder$cur === void 0 ? void 0 : (_state$draftOrder$cur2 = _state$draftOrder$cur.data) === null || _state$draftOrder$cur2 === void 0 ? void 0 : _state$draftOrder$cur2.city_id);
    });
    return (city === null || city === void 0 ? void 0 : (_city$fees_amount = city.fees_amount) === null || _city$fees_amount === void 0 ? void 0 : (_city$fees_amount$ = _city$fees_amount[0]) === null || _city$fees_amount$ === void 0 ? void 0 : _city$fees_amount$["Customer Location"]) || null;
  }, [state === null || state === void 0 ? void 0 : state.draftOrder]);
  var minHeight = useMemo(function () {
    if (__IS_SSR__) {
      return "fit-content";
    }
    return window.innerHeight - 160 - 72 + "px";
  }, []);
  var maxHeight = useMemo(function () {
    var _window;
    if (__IS_SSR__ || !isMobile) {
      return "fit-content";
    }
    return ((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight) - 160 - 88 + "px";
  }, []);
  useEffect(function () {
    var _state$draftOrder2, _state$draftOrder2$cu, _state$draftOrder2$cu2;
    var inspection_type = state === null || state === void 0 ? void 0 : (_state$draftOrder2 = state.draftOrder) === null || _state$draftOrder2 === void 0 ? void 0 : (_state$draftOrder2$cu = _state$draftOrder2.currentStep) === null || _state$draftOrder2$cu === void 0 ? void 0 : (_state$draftOrder2$cu2 = _state$draftOrder2$cu.data) === null || _state$draftOrder2$cu2 === void 0 ? void 0 : _state$draftOrder2$cu2.inspection_location_type_id;
    if (inspection_type) {
      if (inspection_type == 'customer_location') {
        var _state$draftOrder3, _state$draftOrder3$cu, _state$draftOrder3$cu2, _state$draftOrder4, _state$draftOrder4$cu, _state$draftOrder4$cu2, _state$draftOrder5, _state$draftOrder5$cu, _state$draftOrder5$cu2, _state$draftOrder6, _state$draftOrder6$cu, _state$draftOrder6$cu2;
        setSelectedLocation("branch");
        var latitude = state === null || state === void 0 ? void 0 : (_state$draftOrder3 = state.draftOrder) === null || _state$draftOrder3 === void 0 ? void 0 : (_state$draftOrder3$cu = _state$draftOrder3.currentStep) === null || _state$draftOrder3$cu === void 0 ? void 0 : (_state$draftOrder3$cu2 = _state$draftOrder3$cu.data) === null || _state$draftOrder3$cu2 === void 0 ? void 0 : _state$draftOrder3$cu2.latitude;
        var longitude = state === null || state === void 0 ? void 0 : (_state$draftOrder4 = state.draftOrder) === null || _state$draftOrder4 === void 0 ? void 0 : (_state$draftOrder4$cu = _state$draftOrder4.currentStep) === null || _state$draftOrder4$cu === void 0 ? void 0 : (_state$draftOrder4$cu2 = _state$draftOrder4$cu.data) === null || _state$draftOrder4$cu2 === void 0 ? void 0 : _state$draftOrder4$cu2.longitude;
        dataActions.setInspectionLocation({
          type: "customer_location",
          latitude: latitude,
          longitude: longitude,
          mapLink: "https://www.google.com/maps?q=".concat(latitude, ",").concat(longitude, "&z=15"),
          areaId: state === null || state === void 0 ? void 0 : (_state$draftOrder5 = state.draftOrder) === null || _state$draftOrder5 === void 0 ? void 0 : (_state$draftOrder5$cu = _state$draftOrder5.currentStep) === null || _state$draftOrder5$cu === void 0 ? void 0 : (_state$draftOrder5$cu2 = _state$draftOrder5$cu.data) === null || _state$draftOrder5$cu2 === void 0 ? void 0 : _state$draftOrder5$cu2.area_id,
          locationDetails: {
            formatted_address: state === null || state === void 0 ? void 0 : (_state$draftOrder6 = state.draftOrder) === null || _state$draftOrder6 === void 0 ? void 0 : (_state$draftOrder6$cu = _state$draftOrder6.currentStep) === null || _state$draftOrder6$cu === void 0 ? void 0 : (_state$draftOrder6$cu2 = _state$draftOrder6$cu.data) === null || _state$draftOrder6$cu2 === void 0 ? void 0 : _state$draftOrder6$cu2.location
          }
        });
      } else if (inspection_type == 'company_location') {
        var _state$draftOrder7, _state$draftOrder7$cu, _state$draftOrder7$cu2, _state$draftOrder8, _state$draftOrder8$cu, _state$draftOrder8$cu2;
        setSelectedLocation("home");
        dataActions.setInspectionLocation({
          type: "company_location",
          inspection_location_name: state === null || state === void 0 ? void 0 : (_state$draftOrder7 = state.draftOrder) === null || _state$draftOrder7 === void 0 ? void 0 : (_state$draftOrder7$cu = _state$draftOrder7.currentStep) === null || _state$draftOrder7$cu === void 0 ? void 0 : (_state$draftOrder7$cu2 = _state$draftOrder7$cu.data) === null || _state$draftOrder7$cu2 === void 0 ? void 0 : _state$draftOrder7$cu2.inspection_location_name,
          workshopName: state === null || state === void 0 ? void 0 : (_state$draftOrder8 = state.draftOrder) === null || _state$draftOrder8 === void 0 ? void 0 : (_state$draftOrder8$cu = _state$draftOrder8.currentStep) === null || _state$draftOrder8$cu === void 0 ? void 0 : (_state$draftOrder8$cu2 = _state$draftOrder8$cu.data) === null || _state$draftOrder8$cu2 === void 0 ? void 0 : _state$draftOrder8$cu2.company_location_name_en
        });
      }
    } else {
      // Backend has reset the location data (e.g. user went back and changed the city).
      // Clear stale inspection data so WorkshopLocations can pick its default when user selects it.
      dataActions.setInspectionLocation(null);
    }
  }, [state === null || state === void 0 ? void 0 : (_state$draftOrder9 = state.draftOrder) === null || _state$draftOrder9 === void 0 ? void 0 : (_state$draftOrder9$cu = _state$draftOrder9.currentStep) === null || _state$draftOrder9$cu === void 0 ? void 0 : _state$draftOrder9$cu.data]);
  var handleLocationChange = function handleLocationChange(e) {
    setSelectedLocation(e.target.value);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _state$draftOrder0;
      var _state$draftOrder1, _state$draftOrder10, _state$draftOrder10$c, inspectionData, currentCityId, payload, _inspectionData$locat, _state$draftOrder11, _inspectionData$locat2, latitude, longitude, formattedAddress, geoAddress, _state$draftOrder12, _state$draftOrder13, _state$draftOrder13$i, response, _stepData$current_ste, stepData, currentStepKey, _state$draftOrder14, newURL, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(!selectedLocation || !(state !== null && state !== void 0 && (_state$draftOrder0 = state.draftOrder) !== null && _state$draftOrder0 !== void 0 && _state$draftOrder0.requestId))) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsSubmitting(true);
            _context.p = 2;
            inspectionData = (state === null || state === void 0 ? void 0 : (_state$draftOrder1 = state.draftOrder) === null || _state$draftOrder1 === void 0 ? void 0 : _state$draftOrder1.inspectionLocation) || {};
            currentCityId = state === null || state === void 0 ? void 0 : (_state$draftOrder10 = state.draftOrder) === null || _state$draftOrder10 === void 0 ? void 0 : (_state$draftOrder10$c = _state$draftOrder10.currentStep) === null || _state$draftOrder10$c === void 0 ? void 0 : _state$draftOrder10$c.data.city_id; // Build API payload based on selected location type
            if (selectedLocation === "branch") {
              // Customer Location (user's location)
              latitude = (inspectionData === null || inspectionData === void 0 ? void 0 : inspectionData.latitude) || "";
              longitude = (inspectionData === null || inspectionData === void 0 ? void 0 : inspectionData.longitude) || "";
              formattedAddress = inspectionData === null || inspectionData === void 0 ? void 0 : (_inspectionData$locat = inspectionData.locationDetails) === null || _inspectionData$locat === void 0 ? void 0 : _inspectionData$locat.formatted_address;
              geoAddress = formattedAddress || "".concat(latitude, ",").concat(longitude);
              payload = {
                request_id: state.draftOrder.requestId,
                inspection_location_type: "customer_location",
                inspection_location_name: (inspectionData === null || inspectionData === void 0 ? void 0 : inspectionData.workshopName) || "Workshop",
                city_id: currentCityId || "",
                area_id: (inspectionData === null || inspectionData === void 0 ? void 0 : inspectionData.areaId) || "",
                latitude: latitude,
                longitude: longitude,
                map_link: (inspectionData === null || inspectionData === void 0 ? void 0 : inspectionData.mapLink) || "",
                geo_address: geoAddress
              };
              trackEvents("sell_car_location_pick", {
                order_id: state === null || state === void 0 ? void 0 : (_state$draftOrder11 = state.draftOrder) === null || _state$draftOrder11 === void 0 ? void 0 : _state$draftOrder11.requestId,
                inspection_location: "customer_location",
                specific_location: (inspectionData === null || inspectionData === void 0 ? void 0 : (_inspectionData$locat2 = inspectionData.locationDetails) === null || _inspectionData$locat2 === void 0 ? void 0 : _inspectionData$locat2.formatted_address) || "",
                version: "3"
              });
            } else {
              // Company Location (workshop location)
              trackEvents("sell_car_location_pick", {
                order_id: state === null || state === void 0 ? void 0 : (_state$draftOrder12 = state.draftOrder) === null || _state$draftOrder12 === void 0 ? void 0 : _state$draftOrder12.requestId,
                inspection_location: "syarah_location",
                specific_location: state === null || state === void 0 ? void 0 : (_state$draftOrder13 = state.draftOrder) === null || _state$draftOrder13 === void 0 ? void 0 : (_state$draftOrder13$i = _state$draftOrder13.inspectionLocation) === null || _state$draftOrder13$i === void 0 ? void 0 : _state$draftOrder13$i.workshopName,
                version: "3"
              });
              payload = {
                request_id: state.draftOrder.requestId,
                inspection_location_type: "company_location",
                inspection_location_name: (inspectionData === null || inspectionData === void 0 ? void 0 : inspectionData.workshopName) || "Headquarter",
                city_id: currentCityId || ""
              };
            }

            // Submit to API
            _context.n = 3;
            return submitSellTradeStep(payload);
          case 3:
            response = _context.v;
            if (!(response !== null && response !== void 0 && response.data)) {
              _context.n = 5;
              break;
            }
            _context.n = 4;
            return dataActions.fetchStepData();
          case 4:
            stepData = _context.v;
            currentStepKey = stepData === null || stepData === void 0 ? void 0 : (_stepData$current_ste = stepData.current_step) === null || _stepData$current_ste === void 0 ? void 0 : _stepData$current_ste.step_key;
            if (currentStepKey) {
              // TODO: Implement history management here
              newURL = createUrl("/site/sell-my-car", {
                request_id: state === null || state === void 0 ? void 0 : (_state$draftOrder14 = state.draftOrder) === null || _state$draftOrder14 === void 0 ? void 0 : _state$draftOrder14.requestId
              });
              window.history.replaceState({}, null, newURL);
              screenActions.navigateToScreen(currentStepKey);
              // Navigate to the new URL
              navigate(newURL, {
                replace: true
              });
            }
          case 5:
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            console.error("Error submitting inspection location:", _t);
            alert("An error occurred while submitting. Please try again.");
          case 7:
            _context.p = 7;
            setIsSubmitting(false);
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 6, 7, 8]]);
    }));
    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();
  var buttonDisabled = useMemo(function () {
    if (selectedLocation === 'branch') {
      var _state$draftOrder15, _state$draftOrder15$i, _state$draftOrder16, _state$draftOrder16$i, _state$draftOrder17, _state$draftOrder17$i, _state$draftOrder18, _state$draftOrder18$i;
      if (!(state !== null && state !== void 0 && (_state$draftOrder15 = state.draftOrder) !== null && _state$draftOrder15 !== void 0 && (_state$draftOrder15$i = _state$draftOrder15.inspectionLocation) !== null && _state$draftOrder15$i !== void 0 && _state$draftOrder15$i.type) || !(state !== null && state !== void 0 && (_state$draftOrder16 = state.draftOrder) !== null && _state$draftOrder16 !== void 0 && (_state$draftOrder16$i = _state$draftOrder16.inspectionLocation) !== null && _state$draftOrder16$i !== void 0 && _state$draftOrder16$i.areaId) || !(state !== null && state !== void 0 && (_state$draftOrder17 = state.draftOrder) !== null && _state$draftOrder17 !== void 0 && (_state$draftOrder17$i = _state$draftOrder17.inspectionLocation) !== null && _state$draftOrder17$i !== void 0 && _state$draftOrder17$i.latitude) || !(state !== null && state !== void 0 && (_state$draftOrder18 = state.draftOrder) !== null && _state$draftOrder18 !== void 0 && (_state$draftOrder18$i = _state$draftOrder18.inspectionLocation) !== null && _state$draftOrder18$i !== void 0 && _state$draftOrder18$i.longitude)) {
        return true;
      }
    } else if (selectedLocation === 'home') {
      var _state$draftOrder19, _state$draftOrder19$i;
      if (!selectedLocation || !(state !== null && state !== void 0 && (_state$draftOrder19 = state.draftOrder) !== null && _state$draftOrder19 !== void 0 && (_state$draftOrder19$i = _state$draftOrder19.inspectionLocation) !== null && _state$draftOrder19$i !== void 0 && _state$draftOrder19$i.workshopName)) {
        return true;
      }
    }
    return false;
  }, [selectedLocation, state === null || state === void 0 ? void 0 : (_state$draftOrder20 = state.draftOrder) === null || _state$draftOrder20 === void 0 ? void 0 : _state$draftOrder20.inspectionLocation]);

  // Show loading state while data is being fetched
  if (state.draftOrder.isLoadingStepData) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4 flex flex-col gap-4 md:p-6"
    }, /*#__PURE__*/React.createElement(FlowOptionLoading, {
      length: 2,
      gridClassName: "md:flex md:flex-col",
      className: "md:h-[78px]"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-location-screen",
    className: "p-4  flex flex-col gap-4 md:p-6  relative h-full md:min-h-[700px]",
    style: {
      minHeight: minHeight,
      maxHeight: maxHeight,
      overflowY: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-between pb-0 md:min-h-[calc(100%-72px)] flex-1 gap-4",
    style: {
      paddingBottom: smallDevice && selectedLocation ? "80px" : ""
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-location-options",
    className: "flex flex-col gap-4 max-w-[666px] mx-auto w-full md:max-w-full"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-location-option-customer",
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement(RadioCardExpandable, {
    name: "inspection_location",
    value: "branch",
    checked: selectedLocation === "branch",
    onChange: handleLocationChange,
    title: tShort("sell_trade_v2/user_location_inspection_title", {
      ns: "web_sell_trade"
    }),
    className: twMerge("!border-gray-echo", !(dataActions !== null && dataActions !== void 0 && (_dataActions$checkCit = dataActions.checkCityAllowedForInspection) !== null && _dataActions$checkCit !== void 0 && _dataActions$checkCit.customer_location) && "opacity-50"),
    radioCircleClassName: "bg-primary",
    radioMarkClassName: "border-black-primary",
    disabled: !(dataActions !== null && dataActions !== void 0 && (_dataActions$checkCit2 = dataActions.checkCityAllowedForInspection) !== null && _dataActions$checkCit2 !== void 0 && _dataActions$checkCit2.customer_location),
    sideNote: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1"
    }, /*#__PURE__*/React.createElement(Conditional, {
      condition: !!fees
    }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2 items-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-base text-success"
    }, fees), /*#__PURE__*/React.createElement(SAR, {
      className: "text-base text-success"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-black-primary leading-[14px] font-normal"
    }, tShort("sell_trade_v2/inspection_fees", {
      ns: "web_sell_trade"
    }))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2 items-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-base text-success"
    }, tShort("sell_trade_v2/inspection_free"))))))))
  }, /*#__PURE__*/React.createElement(If, {
    condition: selectedLocation === "branch"
  }, /*#__PURE__*/React.createElement(UserLocationInspection, null))), /*#__PURE__*/React.createElement(If, {
    condition: !(dataActions !== null && dataActions !== void 0 && (_dataActions$checkCit3 = dataActions.checkCityAllowedForInspection) !== null && _dataActions$checkCit3 !== void 0 && _dataActions$checkCit3.customer_location)
  }, /*#__PURE__*/React.createElement(ChangeCityModal, null))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-location-option-company",
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement(RadioCardExpandable, {
    name: "inspection_location",
    value: "home",
    checked: selectedLocation === "home",
    onChange: handleLocationChange,
    title: tShort("sell_trade_v2/home_inspection_title", {
      ns: "web_sell_trade"
    }),
    className: twMerge("!border-gray-echo", !(dataActions !== null && dataActions !== void 0 && (_dataActions$checkCit4 = dataActions.checkCityAllowedForInspection) !== null && _dataActions$checkCit4 !== void 0 && _dataActions$checkCit4.company_location) && "!opacity-50"),
    radioCircleClassName: "bg-primary",
    radioMarkClassName: twMerge("border-black-primary"),
    disabled: !(dataActions !== null && dataActions !== void 0 && (_dataActions$checkCit5 = dataActions.checkCityAllowedForInspection) !== null && _dataActions$checkCit5 !== void 0 && _dataActions$checkCit5.company_location),
    sideNote: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2 items-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-base text-success"
    }, tShort("sell_trade_v2/inspection_free")))))
  }, /*#__PURE__*/React.createElement(If, {
    condition: selectedLocation === "home"
  }, /*#__PURE__*/React.createElement(WorkshopLocations, null))), /*#__PURE__*/React.createElement(If, {
    condition: !(dataActions !== null && dataActions !== void 0 && (_dataActions$checkCit6 = dataActions.checkCityAllowedForInspection) !== null && _dataActions$checkCit6 !== void 0 && _dataActions$checkCit6.company_location)
  }, /*#__PURE__*/React.createElement(ChangeCityModal, null)))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-location-banner",
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pe-3 py-1.5 w-full rounded-lg bg-[#F0F4F8] shadow-[0_0_1.2px_0_rgba(0,0,0,0.25)] flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 py-2 ps-3 w-1/2 md:py-4 "
  }, /*#__PURE__*/React.createElement("h4", {
    id: "sell-car-location-banner-title",
    className: "max-w-[180px] md:text-base md:max-w-full"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary-new md:text-2xl  text-xs font-bold"
  }, tShort("sell_trade_v2/banner_title1", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-orange-500  md:text-2xl text-xs font-bold px-0.5"
  }, tShort("sell_trade_v2/banner_title_number", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-primary-new md:text-2xl  text-xs font-bold"
  }, tShort("sell_trade_v2/banner_title2", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("button", {
    id: "sell-car-location-banner-cta",
    className: "border-none outline-none bg-white rounded-full w-fit py-1 px-2 text-primary-new font-semibold text-xss cursor-pointer flex items-center gap-2 md:text-xs md:p-2 md:w-44 md:justify-center",
    onClick: function onClick() {
      faqModal.setTrue();
      trackEvents("how_to_sell_click", {
        referral_location: "inspection_location",
        version: "3"
      });
    }
  }, /*#__PURE__*/React.createElement("span", null, tShort("sell_car_v2/banner_cta", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-left-alt-rounded en:rotate-180",
    className: "text-primary-new",
    width: 3,
    height: 3
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-1/2 flex justify-end"
  }, /*#__PURE__*/React.createElement("img", {
    id: "sell-car-location-banner-image",
    src: "/assets/images/used-car.svg",
    alt: "",
    className: "w-32 h-24 lg:w-[200px] lg:h-[67px]"
  }))))), /*#__PURE__*/React.createElement(FLowFixedContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "md:relative md:max-w-[340px] md:mx-auto md:gap-5 md:!mt-[90px]"
  }, /*#__PURE__*/React.createElement(FlowButton, {
    id: "sell-car-location-submit-btn",
    onClick: handleSubmit,
    disabled: !selectedLocation || isSubmitting || buttonDisabled,
    className: "w-full md:min-w-[360px]"
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: isSubmitting
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null)), /*#__PURE__*/React.createElement(Else, null, tShort("sell_trade_v2/continue", {
    ns: "web_sell_trade"
  })))))), /*#__PURE__*/React.createElement(StepsAndFAQModal, {
    isOpen: faqModal.value,
    onClose: faqModal.setFalse
  }));
};
export default CarLocationPickedScreen;